// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let InterTraderBtnStatus =
{
    Closed: 0,
    Open: 1,
    Call: 2
};
Object.freeze(InterTraderBtnStatus);